import { createAction, props } from '@ngrx/store';
import { AllocateServiceDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-service-wizard/allocate-service-init-step/due-dates-step';
import { AllocateServiceInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-service-wizard/allocate-service-init-step/init-step';

export const selectInitStep = createAction('[V26 User Property Panel] Select Init Step', props<{ initStep: AllocateServiceInitStepV26 }>());

export const exitAllocateServiceWizard = createAction('[V26 Allocate Service Wizard] Exit Allocate Service Wizard');

export const destroyWizard = createAction('[V26 Allocate Service Wizard] Exit Destroy Wizard');

export const selectDueDatesStep = createAction(
  '[V26 Allocate Service Wizard] Select Due Date Step',
  props<{ dueDatesStep: AllocateServiceDueDatesV26 }>(),
);

// export const selectLicenseStep = createAction(
//   '[Allocate Service Wizard] Select Cancel License Services Information Step',
//   props<{ licenseStep: CancelAssetOptions[] }>()
// );

// export const selectAdditionalStep = createAction(
//   '[Allocate Service Wizard] Select Cancel Additional Information Step',
//   props<{ addInfoStep: AdditionalInfo }>()
// );

// export const sendLicenseServicesCancelRequest = createAction(
//   '[Allocate Service Wizard] Create Cancel Information Step',
//   props<{ cancelRequest: CancelLicenseServicesRequest }>()
// );

// export const cancelRequestSuccess = createAction(
//   '[Allocate Service Wizard] Create Cancel Information Step Success',
//   props<{ response: CancelLicenseServicesResponse }>()
// );

// export const cancelRequestFail = createAction(
//   '[Allocate Service Wizard] Create Cancel Information Step Fail',
//   props<{ errorMessage: string }>()
// );
